// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"472716cc","425":"c967929c","510":"aa25c939","532":"414d80e7","633":"944a8fc8","634":"467480a6","922":"046d15f5","937":"b5b4437b","972":"cd00b3ab"}[chunkId] + ".chunk.js";
};